import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

async function refreshCart() {
  const cartItems = document.querySelector('cart-items-component');
  if (cartItems) {
    await customElements.whenDefined('cart-items-component');
    return cartItems.fetchCartData();
  }
  const response = await fetch(`${Theme.routes.cart_url}.json`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
  return response.json();
}

async function addSize(button) {
  const variantId = button.dataset.variantId;
  const productId = button.dataset.productId;
  const original = button.textContent;
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  button.classList.add('is-busy');
  const deferred = CartLinesUpdateEvent.createPromise();

  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    }).then((r) => r.json());

    const cart = await refreshCart();
    const didError = Boolean(response.status);

    if (didError) {
      button.dispatchEvent(
        new CartErrorEvent({
          error: response.message || 'Add to cart failed',
          code: 'INVALID',
          detail: { description: response.description, errors: response.errors },
        })
      );
    }

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'size-quick-add',
        sourceId: `size-quick-add-${variantId}`,
        itemCount: 1,
        productId,
        sections: response.sections,
        didError,
      },
    });

    button.textContent = didError ? '!' : '\u2713';
    if (!didError) button.classList.add('is-done');
  } catch (error) {
    console.error(error);
    deferred.reject(error);
    button.textContent = '!';
  } finally {
    button.classList.remove('is-busy');
    setTimeout(() => {
      button.textContent = original;
      button.classList.remove('is-done');
    }, 1600);
  }
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-size-quick-add] [data-variant-id]') : null;
  if (!button || button.disabled || button.classList.contains('is-busy')) return;
  event.preventDefault();
  event.stopPropagation();
  addSize(button);
});
